import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import HelloSign from 'hellosign-embedded';

class ContractSigning extends Component {
  constructor(props) {
    super(props);
    this.client = null;

  }

  init = () => {
    const { client_id, sign_url, debug } = this.props.signingEmbedConfig;
    this.client = new HelloSign({
      clientId: client_id,
      debug
    });

    this.client.open(sign_url, {
      uxVersion: 2,
      skipDomainVerification: debug,
      allowCancel: false,
      debug,
      hideHeader: true,
    });

    this.client.on('sign', () => {
      this.props.onSuccess();
      this.client.close();
    });
  };

  componentDidMount() {
    if (!isEmpty(this.props.signingEmbedConfig)) {
      this.init();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (isEmpty(prevProps.signingEmbedConfig) && !isEmpty(this.props.signingEmbedConfig)) {
      this.init();
    }
  }

  render() {
    return null;
  }
}

ContractSigning.propTypes = {
  signingEmbedConfig: PropTypes.object.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default ContractSigning;
